/**
 * krypton API
 * Documentation of API endpoints of krypton
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class GenerateReportsCreate400ResponseErrorsInner {
    'code'?: string;
    'detail'?: string;
    'attr'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "code",
            "baseName": "code",
            "type": "string",
            "format": ""
        },
        {
            "name": "detail",
            "baseName": "detail",
            "type": "string",
            "format": ""
        },
        {
            "name": "attr",
            "baseName": "attr",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return GenerateReportsCreate400ResponseErrorsInner.attributeTypeMap;
    }

    public constructor() {
    }
}
